import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import AboutMovement from "@/components/sections/AboutMovement";
import Founder from "@/components/sections/Founder";
import BookSection from "@/components/sections/BookSection";
import Curriculum from "@/components/sections/Curriculum";
import Speaking from "@/components/sections/Speaking";
import Media from "@/components/sections/Media";
import SponsorAYouth from "@/components/sections/SponsorAYouth";
import FinalCTA from "@/components/sections/FinalCTA";
import Footer from "@/components/sections/Footer";
import DonationSuccess from "@/components/pages/DonationSuccess";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";
import AdminAuthCallback from "@/components/admin/AdminAuthCallback";

function Landing() {
  return (
    <div className="relative bg-ink-900 text-white">
      <Navbar />
      <main>
        <Hero />
        <AboutMovement />
        <Founder />
        <BookSection />
        <Curriculum />
        <Speaking />
        <Media />
        <SponsorAYouth />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback (session_id in URL fragment) BEFORE other routes
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AdminAuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/donate/success" element={<DonationSuccess />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#F5E6C8",
            border: "1px solid rgba(197,160,89,0.35)"
          }
        }}
      />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
